import { BaseAccountModel, CountriesType } from '@hwm/ui-lib';
import { PegasusFlowStatusesModel, PegasusStatusModel, PegasusTimeStatusesModel } from '.';

export interface AccountModel extends BaseAccountModel {
  ancestors?: AccountModel[];
  accountParentId?: number;
  description?: string;
  isPmZone?: boolean;
}

export interface UserMainAccountModel extends BaseAccountModel {
  ancestors?: BaseAccountModel[];
  languageCode?: CountriesType;
  userId?: number;
  userName?: string;
  logoUrl?: string;
  useZones?: boolean;
}

export enum AccountAutocompleteFilter {
  All = 'All',
  OnlyPmZone = 'OnlyPmZone',
  OnlyNotPmZone = 'OnlyNotPmZone',
}

export interface CriticalPointModel {
  cpId: number;
  selectedPressureChannel?: number;
}

export interface PMZoneDetails extends Omit<AccountModel, 'id'>, PegasusDataModel {
  accountId: number;
  prValveId?: number;
  criticalPoints?: CriticalPointModel[];
  learningStatus?: string;
  quietStatus?: string;
  nextUpdateTime?: string;
  pastNextUpdateTime?: boolean;
  loggerCalibrationMultiplier?: number;
  controlCreated?: boolean;
}

export interface PegasusDataModel {
  pegasusStatus?: PegasusStatusModel;
  pegasusTimeStatuses?: PegasusTimeStatusesModel[];
  pegasusFlowStatuses?: PegasusFlowStatusesModel[];
}

export interface PMZoneUpdateInformation {
  lastTableUpdate?: string;
  statusLastCheck?: string;
}

export enum PermissionsEnum {
  CanUpdateCallIn = 'Can update call in settings',
  CanEditAcc = 'Can edit accounts',
  CanSubmitPMZSettings = 'Can submit PMZ settings',
  CanEditSites = 'Can edit sites',
}

export enum AppFeatureFlags {
  PegasusPredefinedTables = 'PredefinedTables',
  ECLData = 'ECLData',
}
